<script>
import module from '.';
import NavComponent from './Nav/component.vue';
import HeaderComponent from './Header/component.vue';
import MessageComponent from './Message/component.vue';
import FeatureComponent from './Feature/component.vue';
import AuthenticationComponent from './Authentication/component.vue';
import PhoneComponent from './Phone/component.vue';
import NotifyComponent from './Notify/component.vue';
import ConfirmComponent from './Confirm/component.vue';
import MessageDialog from './Message/Dialog.vue';
import NewsDialog from './News/Dialog.vue';

const style = document.createElement('style');
document.head.appendChild(style);

export default {
  components: {
    NavComponent,
    HeaderComponent,
    FeatureComponent,
    MessageComponent,
    AuthenticationComponent,
    PhoneComponent,
    NotifyComponent,
    ConfirmComponent,
    MessageDialog,
    NewsDialog,
  },
  props: {
    module: {
      type: Object,
      default: () => module,
    },
  },
  data: () => ({
    drawer: null,
    type: true,
    loading: true,
  }),
  methods: {
    setStyle() {
      const v = '#mag-nav-menu .v-list-';
      const color = this.module.setting.get('MenuItemFontColor') || '#ffffff';
      style.innerHTML = `${v}group, ${v}item, ${v}group i, ${v}item i {color: ${color} !important;}`;
    },
  },
  mounted() {
    this.module.init()
      .then(() => {
        this.setStyle();
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
<template>
  <v-app
    v-show="module.show"
  >
    <slot></slot>
    <NavComponent
      v-model="drawer"
      :module="module"
    />
    <HeaderComponent
      v-model="drawer"
      :title="module.title"
      :module="module"
    />
    <MessageDialog :module="module.message"/>
    <NewsDialog :module="module.news"/>
    <FeatureComponent :module="module.feature"/>
    <AuthenticationComponent :module="module.authentication"/>
    <NotifyComponent :module="module.notify"/>
    <div class="mag-template-right">
      <MessageComponent :module="module.message"/>
      <PhoneComponent :module="module.phone"/>
    </div>
    <ConfirmComponent :module="module.confirm"/>
    <v-overlay :value="module.load">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>
<style lang="scss">
  .mag-template-right {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 10000;
  }
</style>
